import type { ActionCreatorsMapObject } from 'redux';

import { useBoundActions } from '../hooks';
import { type reduxActions } from '../reduxActions';

export function boundActionsFactory<A, M extends ActionCreatorsMapObject<A>>(
  getActionCreators: (actions: typeof reduxActions) => M,
): () => M;

export function boundActionsFactory<M extends ActionCreatorsMapObject, N extends ActionCreatorsMapObject>(
  getActionCreators: (actions: typeof reduxActions) => M,
): () => N;

export function boundActionsFactory<A, M extends ActionCreatorsMapObject<A>>(
  getActionCreators: (actions: typeof reduxActions) => M,
): () => M {
  return () => useBoundActions(getActionCreators);
}
